import React, { useEffect } from 'react'
import ym from 'react-yandex-metrika'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import './style.css'

const Cookie = ({ t }) => {

    useEffect(() => {
        ym('hit', '/how-we-use-cookie')
    }, [])

    return (
        <main className="app__content--cookie">
            <Helmet>
                <title>{ `${ t('cookie-text') } ${ t('cookie-link') }` }</title>
            </Helmet>
            <div className="cookie">
                <h1 className="cookie__h1">{ t('cookie-h1') }</h1>
                <p className="cookie__p">{ t('cookie-how-we-use') }</p>
                <h2 className="cookie__h2">{ t('cookie-what-is') }</h2>
                <p className="cookie__p">{ t('cookie-what-is-text') }</p>
                <h2 className="cookie__h2">{ t('cookie-what-we-use') }</h2>
                <p className="cookie__p">{ t('cookie-what-we-use-text') }</p>
                <h2 className="cookie__h2">{ t('cookie-if-dont-want-use') }</h2>
                <p className="cookie__p">{ t('cookie-if-dont-want-use-text') }</p>
                <h2 className="cookie__h2">{ t('cookie-learn-more') }</h2>
                <p className="cookie__p">
                    <a
                        href="mailto:hello@clockwork.one"
                        target="_blank"
                        className="app__link"
                        rel="noopener noreferrer">
                        { t('cookie-learn-more-text') }
                    </a>
                </p>
            </div>
        </main>
    )

}

export default translate('translations')(Cookie)



// WEBPACK FOOTER //
// ./src/Pages/Cookie/index.js